import get from "lodash-es/get";
import orderBy from "lodash-es/orderBy";
import isEmpty from "lodash-es/isEmpty";
import {
  MINIMUM_INVESTMENT_OPTIONS,
  RETURNS_DATA_LIST,
  SORT_DATA_LIST,
  SUBCATEGORY_VIEW_TYPE_MAPPER,
} from "../../constants/diy";
import { PRODUCT_NAMES } from "../../constants/common";

export const getCategoryData = (categories, category) => {
  return categories.find((el) => el.category === category) || {};
};

export const getSubcategories = (categories, category) => {
  const data = getCategoryData(categories, category);
  return get(data, "sub_categories", []);
};

export const getSubcategoryData = (categories, category, subcategory) => {
  const subcategoryData = getSubcategories(categories, category);
  return subcategoryData.find((el) => el.key === subcategory) || {};
};

export const getSubcategoryOptions = (categories, category, subcategory) => {
  const subcategoryData = getSubcategoryData(categories, category, subcategory);
  return subcategoryData.options || [];
};

export const getFilterFundsDataByCategory = (
  fundListData,
  filterData,
  subcategoryOptions
) => {
  let data = {};
  subcategoryOptions.forEach((el) => {
    let fundList = fundListData[el.key];
    if (!isEmpty(fundList)) {
      let filteredList = getFilterFundsData(fundList, filterData);
      data[el.key] = filteredList;
    }
  });
  return data;
};

export const getFilterFundsData = (fundList, filterData) => {
  const {
    fundHouse,
    fundOption,
    minInvestment,
    sortingOrder,
    sortFundsBy,
    returnPeriod,
  } = filterData;
  let filteredFunds = fundList;
  if (!isEmpty(fundHouse)) {
    filteredFunds = filteredFunds.filter((el) =>
      fundHouse.includes(el.fund_house)
    );
  }
  if (fundOption) {
    filteredFunds = filteredFunds.filter(
      (el) => el.growth_or_dividend === fundOption
    );
  }
  if (!isEmpty(minInvestment)) {
    filteredFunds = filteredFunds.filter((el) => {
      const fundMinValue = get(el, "minimum_investment_data", "");
      const lowerLimit = get(minInvestment, "value.lowerLimit", "");
      const upperLimit = get(minInvestment, "value.upperLimit", "");
      if (lowerLimit && !upperLimit && lowerLimit <= fundMinValue) {
        return true;
      }
      if (!lowerLimit && upperLimit && upperLimit >= fundMinValue) {
        return true;
      }
      if (
        lowerLimit &&
        upperLimit &&
        upperLimit >= fundMinValue &&
        lowerLimit <= fundMinValue
      ) {
        return true;
      }
      return false;
    });
  }
  return orderBy(filteredFunds, sortFundsOrder(sortFundsBy, returnPeriod), [
    sortingOrder,
  ]);
};

export const sortFundsOrder = (sortFundsBy, returnPeriod) => (fund) => {
  if (sortFundsBy === "returns") {
    return fund[returnPeriod] || "";
  } else {
    return fund[sortFundsBy] || "";
  }
};

export const mapViewTypeForSubcategories = (categories = []) => {
  return categories.map((data) => {
    let subCategories = get(data, "sub_categories", []);
    subCategories = subCategories.map((el) => {
      return {
        ...el,
        viewType: getSubcategoryViewType(`${data.category}_${el.key}`),
      };
    });
    return {
      ...data,
      sub_categories: subCategories,
    };
  });
};

export const getSubcategoryViewType = (key) => {
  return (
    SUBCATEGORY_VIEW_TYPE_MAPPER[key] || SUBCATEGORY_VIEW_TYPE_MAPPER.default
  );
};

export const getSubcategoryDataByViewType = (
  categories,
  category,
  viewType
) => {
  const categoryData = getCategoryData(categories, category);
  if (isEmpty(categoryData.sub_categories)) {
    return {};
  }
  return (
    categoryData.sub_categories.find((el) => {
      return el.viewType === viewType;
    }) || {}
  );
};

export const getMinimumInvestmentData = (id) => {
  return MINIMUM_INVESTMENT_OPTIONS.find((el) => el.id === id);
};

export const getReturnData = (value) => {
  return RETURNS_DATA_LIST.find((el) => el.value === value);
};

export const getSortData = (value) => {
  return SORT_DATA_LIST.find((el) => el.value === value);
};

export const checkFundPresentInCart = (cartData, fund) => {
  let isPresent = cartData.some((item) => {
    return item.isin === fund.isin;
  });
  return isPresent;
};

export const hideDiyCartFooter = (productName, cartCount) => () => {
  return productName === PRODUCT_NAMES.finity || cartCount <= 0;
};

export const hideDiyCartButton = (productName) => () => {
  return productName === PRODUCT_NAMES.finity;
}

export const getExpectedReturn = (amount, year, invest_type, rateOfInterest) => {
	let projectedValue = 0;
	let principal = parseInt(amount);
	for (let i = 0; i < year; i++) {
		if (invest_type === 'sip') {
			projectedValue = projectedValue + principal * 12;
			projectedValue = projectedValue + (projectedValue * rateOfInterest) / 100;
		} else {
			let currInterest = (principal * rateOfInterest) / 100;
			projectedValue = principal + currInterest;
			principal += currInterest;
		}
	}
	return projectedValue;
};
